import React, { useState, useEffect } from "react";

// AWS
import { API, Auth } from "aws-amplify";

function useTransferCount({ setCountObj, ...query }) {
  const [datas, setDatas] = useState([]);
  const [error, setError] = useState();
  const [count, setCount] = useState(0);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getData(query);
  }, []);

  const getData = async (where) => {
    try {
      setLoading(true);
      const datas = await API.get("MoneyHubAdmin", "/transferLoan/count", {
        queryStringParameters: {
          ...where,
        },
        headers: {
          Authorization: `Bearer ${(await Auth.currentSession())
            .getIdToken()
            .getJwtToken()}`,
        },
      });
      const parseData = JSON.parse(datas.body).Items;
      setCount(datas.count);
      setDatas(parseData);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      setError(true);
      console.log(error);
    }
  };

  return {
    datas,
    setDatas,
    count,
    error,
    setError,
    loading,
    setLoading,
    getData,
  };
}

export default useTransferCount;
